import { memo, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./Jobs.scss";

import jobsData from "data/jobs.json";

const JobItem = memo(function JobItem({ job, workplace, onSelect }) {
  return (
    <div
      className="item-job"
      onClick={() => onSelect(job.slug)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          onSelect(job.slug);
        }
      }}
    >
      <div className="top-item">
        <div className="left-top-item">
          <img
            src={require("assets/images/icons/location.png")}
            className="icon-location"
            alt=""
          />

          <span className="text-location">{workplace}</span>
        </div>
      </div>

      <div className="content-item">
        <span className="title-job">{job.title}</span>
      </div>

      {job.description && (
        <div className="bottom-item">
          <p className="detail-job">{job.description}</p>
        </div>
      )}
    </div>
  );
});

function Jobs() {
  const navigate = useNavigate();

  const jobs = useMemo(() => Object.values(jobsData?.jobs || {}), []);

  const workplace = jobsData?.company?.workplace || "";

  const handleSelectJob = useCallback(
    (slug) => {
      navigate(`/detail-job/${slug}`);
    },
    [navigate],
  );

  return (
    <div className="jobs-page">
      <div className="jobs-wrapper">
        <div className="header-page">
          <div className="header-left">
            <div className="title-header">
              We build <b>world-class tech products</b> used and loved by
              millions. Join us and find meaning in your works.
            </div>
          </div>

          <div className="header-right">
            <img
              className="img-office"
              alt=""
              src={require("assets/images/office.png")}
            />
          </div>
        </div>

        <div className="content-page">
          <div className="jobs-wrapper">
            <div className="header-list-jobs">
              <b>Jobs</b> Opening ({jobs.length})
            </div>

            <div className="list-jobs">
              {jobs.map((job) => (
                <JobItem
                  key={job.slug}
                  job={job}
                  workplace={workplace}
                  onSelect={handleSelectJob}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Jobs;
